export default __webpack_public_path__ + "static/media/new-logo.89611cf3.png";